import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '@services/auth/auth.service';
import { GuiToolsService } from '@services/shared/gui-tools.service';

import Swal from 'sweetalert2';

import { Translators } from 'src/app/services/shared/translators.service';
import { APP_CONFIG, IAppConfig } from '../../app.config/app.config';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { MatDialog } from '@angular/material/dialog';
import { Register } from 'src/app/interfaces/interface-frontend/register';
import { Catalogo } from 'src/app/interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { OpenPageService } from '../../services/shared/open-page.service';
import { GecrosAfiliadosService } from 'src/app/services/entidades/gecros-afiliados.service';
import { SignoGecrosAfiliado } from 'src/app/interfaces/interface-bakend/entidades/signo-greco-afiliado.interface';
import { UsuarioService } from '../../services/shared/usuario.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loadingForm = false;
  showPasswordLogin: boolean;
  loading: Subscription;
  flagLoaded = false;

  constructor(
    private authservice: AuthService,
    private guiToolsService: GuiToolsService,
    public guiMsjService: GuiMsjService,
  ) {
    this.loading = this.guiToolsService.getLoading().subscribe(resp => {
      this.loadingForm = resp;
    });
    this.createforms();
  }


  ngOnInit(): void {
  }

  async login() {
  
          if (this.loginForm.invalid) {
  
              return Object.values(this.loginForm.controls).forEach(control => {
                  control.markAsTouched();
              });
          }
  
          this.authservice.login(
              this.loginForm.value.email,
              this.loginForm.value.password
          );
  
          await this.guiMsjService.msjFormSubmit('Espere');
          Swal.showLoading();
  
  }

  get emailAccess() {
    return this.loginForm.get('email').invalid && this.loginForm.get('email').touched;
  }

  get passwordAccess() {
    return this.loginForm.get('password').invalid && this.loginForm.get('password').touched;
  }

  async createforms() {
    this.createFormLogin();
    this.flagLoaded = true;
  }

  createFormLogin() {
    this.loginForm = new FormGroup({
        email: new FormControl('', [Validators.required,]),
        password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    });

  }
  
}
